import { IAppState } from '../../../AppModulesWrapper';

import { selectMicrofrontendHostName } from '../../../Microfrontend';

import { getCategoryInfo } from '../../utils/category';
import { selectIsByHomeowner, selectOfferCategory } from '../offer';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';

export const selectDisablePromotionSection = (state: IAppState): boolean => {
  const isByHomeowner = selectIsByHomeowner(state);

  const isServicesEnabled = selectIsServicesEnabled(state);

  const hostName = selectMicrofrontendHostName(state);

  const category = selectOfferCategory(state);
  const { rentDuration, propertyType } = getCategoryInfo(category);
  const inCategoriesWithDisable = (!rentDuration || rentDuration === 'long') && propertyType !== 'commercial';

  return !isServicesEnabled && isByHomeowner && !!hostName && inCategoriesWithDisable;
};
